<template>
    <v-progress-linear indeterminate v-if="loading"/>
    <v-container v-else>

        <v-layout class="align-center">
            <v-flex>
                <h2 class="headline">Brukere</h2>
            </v-flex>
            <v-spacer/>
            <v-flex shrink>
                <v-btn text :to="{name: 'UserCreate'}">
                    <v-icon left>add</v-icon>
                    Legg til bruker
                </v-btn>
            </v-flex>
        </v-layout>

        <v-data-table :headers="headers" :items="users" hide-default-footer class="elevation-1" :items-per-page="10000">
            <template v-slot:item="{ item }">
                <tr>
                    <td>{{ item.full_name }}</td>
                    <td>
                        <a :href="`mailto:${ item.email }`">{{ item.email }}</a>
                    </td>
                    <td class="text-center">
                        <v-icon color="green" v-if="item.has_write_access">check_box</v-icon>
                    </td>
                    <td class="text-center" style="width: 1px;">
                        <v-btn text color="primary" :to="{name: 'UserEdit', params: {id: item.id}}">
                            <v-icon left>account_box</v-icon>
                            Rediger bruker
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                users: []
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            loadData() {
                this.loading = true;
                this.$http.get('users').then(response => {
                    this.users = response.data.data;
                }).finally(() => this.loading = false);
            }
        },

        computed: {
            headers() {
                return [
                    {text: 'Navn', value: 'name'},
                    {text: 'Epost / brukernavn', value: 'email'},
                    {text: 'Har skrivetilgang', value: 'has_write_access', align: 'center'},
                    {text: 'Handlinger', value: 'id', align: 'center', sortable: false}
                ]
            }
        }
    }
</script>

<style scoped>
    .contact-link {
        text-decoration: none;
    }

    .contact-link .icon {
        padding-right: 0.25rem;
    }
</style>
